import React from "react";
import { useParams } from "react-router-dom";
import {
    BodyContainer,
    MobileNavigationDrawer,
    SideNavbar
} from "../../components/ui/nav";
import ManagementNavbar from "components/ui/nav/ManagementNavbar";
import { useNavigationDrawer } from "../../context";
import { Header } from "components/ui/header";
import { SupplierInfoProvider } from "layout/context/SupplierInfoContext";
import { useLayoutAccess } from "layout/hooks/anfragenManagerCRMSupplierContainer/useLayoutAccess";

export function AnfragenManagerCRMSupplierContainer() {
    const { secureId } = useParams<{ secureId: string }>();
    const queryParams = new URLSearchParams(window.location.search);
    const token = queryParams.get("token") ?? "";
    const { isNavigationDrawerOpen } = useNavigationDrawer();

    const {
        isAuthenticated,
        supplierName,
        selectedSupplierId,
        currentNavbarSections,
        bookingList,
        farmerName,
        farmerImage
    } = useLayoutAccess({ secureId: secureId!, token });

    return (
        <>
            {isAuthenticated !== undefined &&
                selectedSupplierId != undefined && (
                    <SupplierInfoProvider
                        isAuthenticated={isAuthenticated}
                        supplierId={selectedSupplierId}
                        supplierName={supplierName}
                        bookingList={
                            bookingList == undefined ? undefined : bookingList
                        }
                    >
                        <Header
                            name={farmerName}
                            image={farmerImage}
                            isPartnered={!!bookingList?.length} // true if bookingList exists and has at least one booking
                            showNavigationDrawerIcon
                        />
                        <BodyContainer hideOutlet={isNavigationDrawerOpen}>
                            <aside> <ManagementNavbar
                            />
                            </aside>
                            <MobileNavigationDrawer
                                hidden={!isNavigationDrawerOpen}
                                className="show-small-screen"
                            >
                                {currentNavbarSections.map((section, index) => (
                                    <React.Fragment key={index}>
                                        <ManagementNavbar
                                        />
                                        <div className="col-12 separator" />
                                    </React.Fragment>
                                ))}
                            </MobileNavigationDrawer>
                        </BodyContainer>
                    </SupplierInfoProvider>
                )}
        </>
    );
}
